import { useState } from 'react'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import EmailSent from './EmailSent'
import EmailForm from './EmailForm'
import LoaderWithErrorHandler from '../../components/PageHelpers/LoaderWithErrorHandler'
import { userAuthResetAlertHandler } from '../../redux/features/userAuth/userAuthThunk'
import { selectAuthUser } from '../../redux/features/userAuth/userAuthSlice'
import UseTranslation from '../../hooks/UseTranslation'

const ForgetPassword = () => {
  const userAuth = useSelector(selectAuthUser)
  const [sendEmail, setSendEmail] = useState(false)
  const { t } = UseTranslation()
  return (
    <Box sx={styles.leftSideContainer}>
      <Typography variant={'h4'} sx={styles.formTitle}>
             {t?.['Forgot Password !']}
      </Typography>
    {sendEmail ? (
     <EmailSent />
    ) : (
     <EmailForm setSendEmail={setSendEmail} />
    )}
         <LoaderWithErrorHandler store={userAuth}
        resetAlertHandler={userAuthResetAlertHandler} />
</Box>
  )
}
const styles = {

  leftSideContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: { xs: 'center', sm: 'flex-start' },
    width: { xs: '100%', sm: 'min(100%, 500px)', md: 'min(100%, 620px)' },
    maxHeight: '336px',
    height: '100%',
    marginTop: { xs: '0px', sm: '20px' },
    marginLeft: { xs: '0px', sm: '30px' },
    px: '10px',
    zIndex: '2',
  },
  formTitle: {
    color: 'primary.contrastText',
    my: { xs: '10px', sm: '15px' },
    fontSize: { xs: '18px', sm: '28px' },
    textAlign: { xs: 'unset', sm: 'left' },
    lineHeight: { xs: '25px', sm: '43.74px' },
    fontWeight: 800,
  },
}
export default ForgetPassword
